export default __webpack_public_path__ + "static/media/solid-star.eb5776f4.svg";